'use client';

import { useState } from 'react';
import type { ProductCardTab } from '@/app_components/AffiliateProductCard/types';
import { DescriptionParser } from '@/app_lib/htmlParser/DescriptionParser';
import { options } from '@/app_lib/htmlParser/parsers/parserOptions';
import { ContentPlacement } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';

const MAX_WIDTH = 100; // For a Tab Name

export const ProductCardTabs = ({ tabs }: { tabs: ProductCardTab[] }) => {
  const [currentTab, setCurrentTab] = useState<number>(0);
  if (tabs.length === 0) {
    return null;
  }

  return (
    <div
      className='flex flex-col gap-lg'
      data-cy={ContentPlacement.AffiliateProductCardTabs}
      style={{
        ['--tab-max-width' as string]: `${MAX_WIDTH / tabs.length}%`,
      }}
    >
      <div className='relative min-w-0'>
        <div className='absolute inset-x-0 bottom-0 border-b stroke-secondary' />
        <div className='flex min-w-0 items-end overflow-x-auto scrollbar-hidden'>
          {tabs.map((tab, index) => (
            <button
              aria-label={`View tab ${index + 1}`}
              className={cn(
                'z-10 shrink-0 cursor-pointer border-b px-sm py-xxs font-graphik-compact typography-default font-medium md:max-w-[var(--tab-max-width)]',
                currentTab === index ? 'border-accent text-accent' : 'text-secondary border-transparent',
              )}
              key={tab.name}
              onClick={() => setCurrentTab(index)}
              type='button'
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      <DescriptionParser
        className='[&_p]:typography-sm [&_p]:text-secondary [&_p_strong]:font-graphik [&_p_strong]:typography-xs [&_strong]:text-primary 
			[&_strong]:font-medium [&_a]:text-accent [&_a]:font-medium [&_a]:hover:underline [&_a]:disabled:hover:no-underline 
			[&_a]:aria-disabled:hover:no-underline [&_ul]:list-outside [&_ul]:pl-6 [&_li]:typography_sm [&_li_ul]:pl-4 [&_ul]:flex [&_ul]:flex-col 
			[&_ul]:gap-sm [&_ol]:list-outside [&_ol]:pl-1 [&_li_ol]:pl-4 [&_li]:text-secondary [&_li]:typography-sm [&_*]:font-graphik-compact'
        content={tabs[currentTab].content}
        options={options}
      />
    </div>
  );
};
